import { RequestCapability, requestExtension } from '@hatsy/hatsy/core.js';
import { simpleRoutePattern, urlRoute } from '@hatsy/route-match';
import { noop } from '@proc7ts/primitives';
/**
 * @internal
 */
function buildURLRoute(context) {
    const { requestAddresses } = context;
    return urlRoute(requestAddresses.url);
}
/**
 * @internal
 */
class RoutingCapability extends RequestCapability {
    for;
    constructor(config) {
        super();
        const routePattern = config.routePattern
            ? config.routePattern.bind(config)
            : simpleRoutePattern;
        const buildRoute = config.buildRoute
            ? config.buildRoute.bind(config)
            : buildURLRoute;
        this.for =
            (handler) => context => {
                const route = buildRoute(context);
                return context.next(handler, requestExtension({
                    fullRoute: route,
                    route,
                    routeMatch: noop,
                    routePattern(pattern) {
                        return routePattern(pattern, this);
                    },
                }));
            };
    }
    with(config) {
        return new RoutingCapability(config);
    }
}
/**
 * Request routing capability instance.
 *
 * Can be used directly (for HTTP requests), or {@link Routing.with configured} first.
 */
export const Routing = /*#__PURE__*/ new RoutingCapability({});
//# sourceMappingURL=routing.capability.js.map